<template>
    <div class="apaympro-container">
        <!-- Loader -->
        <loading
            :active.sync="isLoading"
            :can-cancel="false"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
            loader="bars"
            :opacity="1"
        ></loading>

        <!-- Return to search for a merchant -->
        <router-link 
            style="
                position: absolute;
                left: 25px;
                margin-top: 15px;
                margin-bottom: 10px;
                width: 100px; 
                z-index: 100;
                cursor: pointer;
                font-size: 20px;
            "
            class="element-wrap element-wrap-on-left"
            to="/"
        >
            <i class="fas fa-home"></i>
        </router-link>

        <!-- Form Receipt -->
        <div class="apaympro-wrapper animated fadeIn" v-if="hideReceipt">
            <div class="apaympro-page"> 
                <div class="mb-3"
                    style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    "
                >
                    <div class="container">
                        <a :href="'https://cabine.apaym.com/'"
                            class="btn btn-link btn-block" 
                            style="font-weight:800; color: #0e2abd;"
                        >
                            Faire un autre rechargement
                        </a>
                        
                        <div style="display: flex; align-items: center; justify-content: center;">
                            <span 
                                class="text-center" 
                                style="font-size: 12px; font-weight: 600;"
                            >
                                Partager le reçu sur
                            </span>
                            <!-- Whatsapp -->
                            <ShareNetwork
                                network="WhatsApp"
                                :url="'https://cabine.apaym.com/recu/'+ url_data.ref"
                                :title="'Voilà mon reçu !'"
                                :description="'Téléchargez votre reçu pour le rechargement effectué via Mobile Money le '+ dataPage.date_paiement"
                                class="btn btn-link btn-lg btn-whatsapp"
                                style="line-height: 0; padding-left: 13px !important; padding-right: 13px !important;"
                            >
                                <i style="font-size: 22px;" class="fab fa-whatsapp"></i>
                            </ShareNetwork>
                            <!-- Telegram -->
                            <ShareNetwork
                                network="telegram"
                                :url="'https://cabine.apaym.com/recu/'+ url_data.ref"
                                :title="'Voilà mon reçu !'"
                                :description="'Téléchargez votre reçu pour le rechargement effectué via Mobile Money le '+ dataPage.date_paiement "
                                class=" btn-link btn-lg btn-telegram"
                                style="line-height: 0; padding-left: 13px !important; padding-right: 13px !important;"
                            >
                                <i style="font-size: 22px;" class="fab fa-telegram"></i>
                            </ShareNetwork>
                        </div>
                    </div>
                </div>

                <div class="body">
                    <img 
                        src="../assets/recu.png" 
                        alt="Logo zigzag" 
                        style="
                            transform: rotate(180deg);
                            position: relative;
                            top: 10px;
                            z-index: 10;
                        "
                    />

                    <div
                        class="payment-success container animated fadeIn text-center"
                        style="box-shadow: 0px 10px 50px 5px hsl(200deg 6% 80%); border: none !important;"
                    >
                        <div ref="document" class="container animated fadeIn text-center">
                            <div class="apaympro-header mb-3" style="margin-top: 0; ">
                                <div>
                                    <img
                                        src="../assets/Logo-APAYM-Cabine.jpg"
                                        alt="APaym Cabine Logo"
                                        width="300"
                                    />
                                </div> 
                            </div>
                            <div class="pt-3" style="border-top: 1px dashed; ">
                                <strong class="font-18" v-if="dataPage.type == 'rechargement'">
                                    REÇU DE RECHARGEMENT
                                </strong>
                                <br>
                                <span class="font-14 text-secondary" style="font-weight: 900;">
                                    {{ dataPage.date_paiement | formatDateJour }}
                                </span> 
                            </div>

                            <div class="mt-3"
                                style="
                                    border-top: 1px dashed; 
                                    display: flex; 
                                    flex-direction: column; 
                                    border-bottom: 1px dashed; 
                                    align-items: flex-start;
                                    line-height: 1.4rem;
                                "
                            >
                                <img 
                                    src="../assets/Tampons-Apaym.png" 
                                    alt="Logo tampon" 
                                    style="
                                        position: absolute;
                                        top: 40%;
                                        left: 52%;
                                    "
                                    width="230"
                                />
                                
                                <!-- Carte à créditer -->
                                <span class="font-13 mt-3 text-secondary" style="font-weight: 600;"> 
                                    Carte créditée
                                </span>
                                <span class="font-18" style="font-weight: 900; text-align: left; line-height: 1.3">
                                    {{ dataPage.issuer_name }} <br>
                                    Visa {{ dataPage.pan }}
                                </span>
                                <!-- Carte à créditer -->

                                <!-- Montant crédité -->
                                <span class="font-13 mt-3 text-secondary" style="font-weight: 600;"> 
                                    Montant crédité
                                </span>
                                <span class="mt-1" style="font-weight: 900; font-size: 2rem;">
                                    {{ dataPage.montant_a_recharger }} F
                                </span>
                                <!-- Montant crédité -->

                                <!-- Mode de rechargement -->
                                <span class="font-13 mt-3 text-secondary" style="font-weight: 600;"> 
                                    Mode de rechargement
                                </span>
                                <span class="font-18" style="font-weight: 900;">
                                    {{ dataPage.mode_rechargement }}
                                </span>
                                <!-- Mode de rechargement -->

                                <!-- Numéro de rechargement -->
                                <span class="font-13 mt-3 text-secondary" style="font-weight: 600;" v-if="dataPage.numero_rechargement"> 
                                    Numéro de rechargement
                                </span>
                                <span 
                                    class="font-18" 
                                    style="font-weight: 900;" 
                                    v-if="dataPage.numero_rechargement"
                                >
                                    {{ dataPage.numero_rechargement }}
                                </span>
                                <!-- Numéro de rechargement -->

                                <!-- Frais -->
                                <span class="font-13 mt-3 text-secondary" style="font-weight: 600;"> 
                                    Frais
                                </span>
                                <span class="font-18" style="font-weight: 900;">
                                    {{ dataPage.frais }} F
                                </span>
                                <!-- Frais -->

                                <!-- Date de rechargement -->
                                <span class="font-13 mt-3 text-secondary" style="font-weight: 600;"> 
                                    Date de rechargement
                                </span>
                                <span class="font-18" style="font-weight: 900;">
                                    {{ dataPage.date_rechargement | formatDate }}
                                </span>
                                <!-- Date de rechargement -->

                                <!-- Référence -->
                                <span class="font-13 mt-3 text-secondary" style="font-weight: 600;"> 
                                    Référence
                                </span>
                                <span class="font-18 mb-3" style="font-weight: 900;">
                                    {{ dataPage.reference }}
                                </span>
                                <!-- Référence -->
                            </div>

                            <div class="mt-4">
                                <h2 style="font-weight: 900;">
                                    MERCI
                                </h2>
                            </div>
                        </div>

                    </div>
                    <img 
                        src="../assets/recu.png" 
                        alt="Logo zigzag" 
                        style="
                            transform: rotate(0deg);
                            margin-top: -32px;
                        "
                    />

                    <div class="element-wrap element-wrap-for-submit mt-5 mb-5 container">
                        <button class="btn btn-dark btn-block" @click="exportToPDF">
                            Télécharger votre reçu
                        </button>
                        
                        <a :href="'https://cabine.apaym.com/'"
                            class="btn btn-link btn-block" 
                            style="font-weight:800; color: #0e2abd;"
                        >Terminer</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- Form Receipt -->
    </div>
</template>


<script>

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import axios from 'axios';
    import { apiUrl } from '../constants/config';
    import html2pdf from 'html2pdf.js';

    export default {
        name: 'RecuRechargementPage',
        metaInfo() {
            return {
                title: "Reçu de rechargement cartes Visa prépayées | APAYM Cabine",
                meta: [
                    {
                        vmid: "description",
                        name: "description",
                        content: "Obtenez votre reçu de rechargement de vos cartes Visa prépayées ici."
                    }
                ]
            };
        },
        components: {
            Loading,
        },
        data() {
            return {
                url_data: {
                    ref: ""
                },
                hideReceipt: false,
                isLoading: false,
                fullPage: true,
                dataPage: {
                    issuer_name: "",
                    pan: "",
                    montant_a_recharger: "",
                    frais: "",
                    date_paiement: "",
                    numero_rechargement: "",
                    mode_rechargement: "",
                    date_rechargement: "",
                    reference: "",
                    type: ""
                },
                langs: ['fr', 'en'],
                hideSharing: true
            }
        },
        computed: {
        },
        methods: {

            onCancel() {
                console.log('Loader dismiss') ;
            },

            exportToPDF () {
				html2pdf(this.$refs.document, {
					margin: 1,
					filename: 'Reçu de rechargement - Carte Visa '+ this.dataPage.pan +'.pdf',
					image: { type: 'jpeg', quality: 0.98 },
					html2canvas: { dpi: 192, letterRendering: true },
					jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
				}) ;
			},

            showReceipt(ref){

                this.isLoading = true;

                let dataSend = new FormData();
                dataSend.append("reference", ref);

                axios.post(apiUrl + 'api/check-reference',
                    dataSend
                ).then(response => {

                    this.isLoading = false;

                    if (response.data.code !== 1) {
                        localStorage.clear() ;
                        sessionStorage.clear() ;
                        window.location.href = "https://cabine.apaym.com" ;
                        return false;
                    }

                    if (response.data.reference !== this.url_data.ref) {
                        localStorage.clear() ;
                        sessionStorage.clear() ;
                        window.location.href = "https://cabine.apaym.com" ;
                        return false;
                    }

                    // Get infos 
                    this.dataPage.pan = response.data.pan ;
                    this.dataPage.issuer_name = response.data.issuer_name ;
                    this.dataPage.montant_a_recharger = response.data.montant_a_recharger ;
                    this.dataPage.frais = response.data.frais ;
                    this.dataPage.numero_rechargement = response.data.numero_rechargement ;
                    this.dataPage.mode_rechargement = response.data.mode_rechargement ;
                    this.dataPage.reference = response.data.reference ;
                    this.dataPage.date_paiement = response.data.date_paiement ;
                    this.dataPage.date_rechargement = response.data.date_rechargement ;
                    this.dataPage.type = response.data.type ;
                    
                    // Show receipt bloc
                    this.hideReceipt = true ;

                }).catch(error => {

                    this.isLoading = false;
                    this.$swal(
                        'Une erreur est survenue !',
                        error,
                        'error'
                    );

                });
                
            },
            
        },
        mounted() {

            this.url_data.ref = this.$route.params.reference;

            if (!this.url_data.ref) {
                localStorage.clear() ;
                sessionStorage.clear() ;
                window.location.href = "https://cabine.apaym.com/" ;
                return false;
            }

            this.showReceipt(this.url_data.ref);
        },
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 
</style>
